module.exports = __webpack_public_path__ + "static/img/IMG_20150610_193440.9f0eed99.jpg";